export const SurveyType = {
    SINGLECHOICE: "SurveyType.SINGLECHOICE",
    MULTIPLECHOICE: "SurveyType.MULTIPLECHOICE",
    FREEANSWER: "SurveyType.FREEANSWER"
};
